import { render, staticRenderFns } from "./left-main-menu.vue?vue&type=template&id=52d658f4&"
import script from "./left-main-menu.vue?vue&type=script&lang=js&"
export * from "./left-main-menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploy/cp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52d658f4')) {
      api.createRecord('52d658f4', component.options)
    } else {
      api.reload('52d658f4', component.options)
    }
    module.hot.accept("./left-main-menu.vue?vue&type=template&id=52d658f4&", function () {
      api.rerender('52d658f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/packs/components/menus/left-main-menu.vue"
export default component.exports